import { initializeApp, getApps, getApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyC4VqcYmSdfhflOFiOJ_VJhE17K6LoISJE",
  authDomain: "votelist-5dd71.firebaseapp.com",
  projectId: "votelist-5dd71",
  storageBucket: "votelist-5dd71.firebasestorage.app",
  messagingSenderId: "256377592488",
  appId: "1:256377592488:web:2291a5137d554a2ee0409d",
  measurementId: "G-L9X8E8S0RY"
};

const app = getApps().length ? getApp() : initializeApp(firebaseConfig);
export const db = getFirestore(app);
export default app;
